var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22544 11.0432L1.43144 6.0432C1.01011 5.6222 0.732024 5.07923 0.636623 4.4913C0.541223 3.90337 0.633352 3.30033 0.899943 2.7677C1.10097 2.36576 1.39463 2.01734 1.75672 1.75114C2.11881 1.48495 2.53896 1.3086 2.98257 1.23662C3.42618 1.16465 3.88054 1.19911 4.30822 1.33717C4.73589 1.47523 5.12465 1.71294 5.44244 2.0307L6.22544 2.8132L7.00844 2.0307C7.32624 1.71294 7.71499 1.47523 8.14267 1.33717C8.57035 1.19911 9.02471 1.16465 9.46832 1.23662C9.91192 1.3086 10.3321 1.48495 10.6942 1.75114C11.0563 2.01734 11.3499 2.36576 11.5509 2.7677C11.8172 3.30012 11.9092 3.9028 11.8138 4.4904C11.7185 5.07799 11.4408 5.62071 11.0199 6.0417L6.22544 11.0432Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.3aa6cf69d54125368fa8d500b176cd9e.svg";
export { ForwardRef as ReactComponent };